export const {
  REACT_APP_GRAPHQL_ENDPOINT = 'https://api.thegraph.com/subgraphs/name/onomyprotocol/ograph',
  REACT_APP_BONDING_NOM_CONTRACT_ADDRESS = '0x52A4A4FBB36A2f6A83dBf7De9425C1ec5FF528Da',
  REACT_APP_WNOM_CONTRACT_ADDRESS = '0xe7c0fd1f0A3f600C1799CD8d335D31efBE90592C',
  REACT_APP_GRAVITY_CONTRACT_ADDRESS = '0x1A973849245b114a1E2DaFDa9B1Be46C509dB73B',
} = process.env;
